var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx, css, classNames } from 'jimu-core';
import { Icon } from './icon';
const useStyle = (iconSize) => {
    return css `
    pointer-events: none;
    background-color: var(--ref-palette-neutral-300);
    border: 1px solid var(--ref-palette-neutral-700);
    width: 100%;
    height: 100%;
    color: var(--ref-palette-neutral-1000);
    padding: ${iconSize === 'large' ? '2.5%' : '0px'};
    .picture-wrapper, .thumbnail-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .picture-wrapper {
      .jimu-icon{
        color: var(--ref-palette-neutral-600);
      }
    }
    .thumbnail-wrapper {
      flex-direction: column;
      .jimu-icon{
        color: var(--ref-palette-neutral-1000);
      }
    }
  `;
};
/**
 * The `WidgetPlaceholder` component is applied in widgets prior to all settings have been chosen by the experience author.
 *
 * ```ts
 * import { WidgetPlaceholder } from 'jimu-ui'
 * ```
 */
export const WidgetPlaceholder = (props) => {
    var _a;
    const { iconSize = 'small', widgetId, className, icon, message, style, autoFlip = false } = props, others = __rest(props, ["iconSize", "widgetId", "className", "icon", "message", "style", "autoFlip"]);
    const cssStyle = useStyle(iconSize);
    const isInBuilder = (_a = window.jimuConfig) === null || _a === void 0 ? void 0 : _a.isInBuilder;
    return (jsx("div", Object.assign({ css: cssStyle }, others, { className: classNames('jimu-widget-placeholder', className) }),
        iconSize === 'large' && jsx("div", { className: 'picture-wrapper' },
            jsx(Icon, { icon: icon, className: 'w-100 h-100', autoFlip: autoFlip })),
        iconSize === 'small' && jsx("div", { className: 'thumbnail-wrapper pt-1' },
            jsx(Icon, { icon: icon, size: 'l', autoFlip: autoFlip }),
            isInBuilder && jsx("div", { className: 'message-wrapper text-center mt-2' }, message))));
};
